import { Component, computed, input, output, signal, viewChild } from '@angular/core';
import {
  RidContentCard,
  RidMechanicBackground,
  RidMechanicContent,
  RidMechanicTitle,
  RidMechanicWrapper,
  RidOverlayFeedback,
  RidTopBar,
} from '../../components';
import { AudioEffectPlayer } from '../../utils/audio.utils';

@Component({
  selector: 'rid-compare',
  imports: [RidMechanicBackground, RidMechanicWrapper, RidTopBar, RidMechanicContent, RidMechanicTitle, RidOverlayFeedback, RidContentCard],
  templateUrl: './rid-compare.html',
  host: {
    class: 'block',
  },
})
export class RidCompare {
  questions = input.required<{ id: string; options: string[]; answer: number }[]>();

  index = signal(0);
  question = computed(() => this.questions()[this.index()]);

  progress = signal(0);
  isChecking = signal(false);
  overlayFeedback = viewChild.required<RidOverlayFeedback>('overlayFeedback');
  chosen = signal<undefined | number>(undefined);

  finished = output<void>();

  async choose(index: number) {
    this.chosen.set(index);
    this.isChecking.set(true);

    if (index === this.question().answer) {
      AudioEffectPlayer.play('CORRECT');
      const isLastIndex = this.index() === this.questions().length - 1;

      if (isLastIndex) this.progress.set(this.progress() + 1);

      await this.overlayFeedback().showCorrect();

      if (isLastIndex) {
        this.finished.emit();
      } else {
        this.progress.set(this.progress() + 1);
        this.index.set(this.index() + 1);
      }
    } else {
      AudioEffectPlayer.play('INCORRECT');
      await this.overlayFeedback().showIncorrect();
    }

    this.chosen.set(undefined);
    this.isChecking.set(false);
  }
}
